import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=1b330df8&scoped=true"
import script from "./Farm.vue?vue&type=script&lang=js"
export * from "./Farm.vue?vue&type=script&lang=js"
import style0 from "./Farm.vue?vue&type=style&index=0&id=1b330df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b330df8",
  null
  
)

export default component.exports